import { API_URL } from '../constants';
import fetchAuthorization from './fetchAuthorization';
import { getErrorMessage } from '../helpers';

export interface GameData {
  game_id: string;
  game_date: string;
  tournament_id: string;
  sport_id: number;
  tournament_name: string;
  bracket_year: number;
  away_team_id: string;
  home_team_id: string;
  away_team_score: number;
  home_team_score: number;
}

export async function addGames(data: GameData): Promise<any> {
  try {
    const response = await fetchAuthorization(`${API_URL}games`, {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(data),
    });

    const result = await response.json();

    if (response.status !== 200) {
      const message = getErrorMessage(result);
      throw new Error(message ? message : `Status Code: ${response.status}. Something went wrong. Please try again later.`);
    }

    return result;
  } catch (e: any) {
    throw new Error(`Unable to add game. ${e.message}`);
  }
}

export default addGames;
